import { render, staticRenderFns } from "./ColumnTransactionStatuseSitef.vue?vue&type=template&id=7821d06b&scoped=true"
import script from "./ColumnTransactionStatuseSitef.vue?vue&type=script&lang=js"
export * from "./ColumnTransactionStatuseSitef.vue?vue&type=script&lang=js"
import style0 from "./ColumnTransactionStatuseSitef.vue?vue&type=style&index=0&id=7821d06b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7821d06b",
  null
  
)

export default component.exports